import {Input} from "@progress/kendo-react-inputs"
import {MDBCol, MDBRow} from "mdbreact"
import React from "react"
import {RootState} from "../../../rootReducer"
import {useAppSelector} from "../../../store"

const BasicUserDetails = () => {
    const roles = useAppSelector((state: RootState) => state.containers.users.roles)
    const selectedUser = useAppSelector((state: RootState) => state.containers.users.selectedUser)
    const selectedUserRole = useAppSelector((state: RootState) => state.containers.users.selectedUserRole)
    const userDetailsLoading = useAppSelector((state: RootState) => state.containers.users.userDetailsLoading)
    return (
        <fieldset className="mb-2">
            <MDBRow className="pt-0">
                <MDBCol md="6" className="mb-2">
                    <Input
                        name={"FirstName"}
                        label={"First name"}
                        value={selectedUser.firstName === null ? "" : selectedUser.firstName}
                        disabled={selectedUser.appUserId !== "" || userDetailsLoading}
                    />
                </MDBCol>
                <MDBCol md="6" className="mb-2">
                    <Input
                        name={"LastName"}
                        label={"Last name"}
                        value={selectedUser.lastName === null ? "" : selectedUser.lastName}
                        disabled={selectedUser.appUserId !== "" || userDetailsLoading}
                    />
                </MDBCol>
                <MDBCol md="6" className="mb-2">
                    <Input
                        name={"Email"}
                        type={"email"}
                        label={"Email"}
                        value={selectedUser.emailAddress}
                        disabled={selectedUser.appUserId !== "" || userDetailsLoading}
                    />
                </MDBCol>

                <MDBCol md="6" className="mb-2">
                    {roles && (
                        <Input
                            name={"Roles"}
                            label={"Role"}
                            value={selectedUserRole?.displayName.toString()}
                            disabled={true}
                        />
                    )}
                </MDBCol>
            </MDBRow>
        </fieldset>
    )
}

export default BasicUserDetails
